module.exports = __webpack_public_path__ + "img/shoppingcart-white.116eb7da.png";